import React, { useRef, useState } from "react";
import { Play, Pause } from "lucide-react";

import "./VideoEmbed.scss";

interface VideEmbedProps {
  src: string;
  poster?: string;
  title?: string;
  description?: string;
  autoplay?: boolean;
  controls?: boolean;
}

export function VideoEmbed({
  src,
  poster,
  title,
  description,
  autoplay = false,
  controls = false,
}: VideEmbedProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(autoplay);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <section className="videoEmbedSection">
      <div className="videoEmbedContainer">
        {(title || description) && (
          <div className="videoEmbedHeader">
            {title && <h2 className="videoEmbedTitle">{title}</h2>}
            {description && (
              <p className="videoEmbedDescription">{description}</p>
            )}
          </div>
        )}

        <div className="mediaBleedMobile">
          <div className="videoWrapper">
            <video
              ref={videoRef}
              className="videoPlayer"
              controlsList="nodownload noremoteplayback"
              poster={poster}
              controls={controls}
              autoPlay={autoplay}
              loop
              playsInline
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
              onContextMenu={(e) => e.preventDefault()}
            >
              <source src={src} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            {!controls && (
              <button
                className="videoPlayButton"
                onClick={togglePlay}
                aria-label={isPlaying ? "Pause video" : "Play video"}
              >
                {isPlaying ? (
                  <Pause className="videoIcon" />
                ) : (
                  <Play className="videoIcon" />
                )}
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
